<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g>
      <g style="opacity: 0">
        <rect x="0" y="0" width="16" height="16" rx="0" fill="#FFFFFF" fill-opacity="1" />
        <rect
          x="0.5"
          y="0.5"
          width="15"
          height="15"
          rx="0"
          fill-opacity="0"
          stroke-opacity="0"
          stroke="currentColor"
          fill="none"
          stroke-width="1"
        />
      </g>
      <g>
        <g>
          <ellipse
            cx="7.999999523162842"
            cy="7.999999761581421"
            rx="4.199999809265137"
            ry="4.199999809265137"
            fill="currentColor"
            fill-opacity="1"
          />
          <ellipse
            cx="7.999999523162842"
            cy="7.999999761581421"
            rx="3.6999998092651367"
            ry="3.6999998092651367"
            fill-opacity="0"
            stroke-opacity="1"
            stroke="currentColor"
            fill="none"
            stroke-width="1"
          />
        </g>
        <g>
          <path
            d="M7.499999046325684,3.1L7.499999046325684,1L8.499999046325684,1L8.499999046325684,3.1L7.499999046325684,3.1Z"
            fill-rule="evenodd"
            fill="currentColor"
            fill-opacity="1"
          />
        </g>
        <g transform="matrix(0,1,-1,0,22.99999713897705,-6.999999046325684)">
          <path
            d="M14.499998092651367,10.099999046325683L14.499998092651367,7.999999046325684L15.499998092651367,7.999999046325684L15.499998092651367,10.099999046325683L14.499998092651367,10.099999046325683Z"
            fill-rule="evenodd"
            fill="currentColor"
            fill-opacity="1"
          />
        </g>
        <g transform="matrix(0,1,-1,0,11.099998950958252,4.899999141693115)">
          <path
            d="M2.5999999046325684,10.099999046325683L2.5999999046325684,7.999999046325684L3.5999999046325684,7.999999046325684L3.5999999046325684,10.099999046325683L2.5999999046325684,10.099999046325683Z"
            fill-rule="evenodd"
            fill="currentColor"
            fill-opacity="1"
          />
        </g>
        <g
          transform="matrix(0.7071067690849304,0.7071067690849304,-0.7071067690849304,0.7071067690849304,5.995180426389908,-8.273645601555273)"
        >
          <path
            d="M12.484764099121094,5.199999904632568L12.484764099121094,3.0999999046325684L13.484764099121094,3.0999999046325684L13.484764099121094,5.199999904632568L12.484764099121094,5.199999904632568Z"
            fill-rule="evenodd"
            fill="currentColor"
            fill-opacity="1"
          />
        </g>
        <g
          transform="matrix(0.7071067690849304,0.7071067690849304,-0.7071067690849304,0.7071067690849304,9.47457453567516,0.12635365087520256)"
        >
          <path
            d="M4.084765195846558,13.6L4.084765195846558,11.5L5.084765195846558,11.5L5.084765195846558,13.6L4.084765195846558,13.6Z"
            fill-rule="evenodd"
            fill="currentColor"
            fill-opacity="1"
          />
        </g>
        <g
          transform="matrix(-0.7071067690849304,0.7071067690849304,0.7071067690849304,0.7071067690849304,1.9056085279302906,-0.7893288267723833)"
        >
          <path
            d="M1.9003416299819946,5.199999904632568L1.9003416299819946,3.0999999046325684L2.9003416299819946,3.0999999046325684L2.9003416299819946,5.199999904632568L1.9003416299819946,5.199999904632568Z"
            fill-rule="evenodd"
            fill="currentColor"
            fill-opacity="1"
          />
        </g>
        <g
          transform="matrix(-0.7071067690849304,0.7071067690849304,0.7071067690849304,0.7071067690849304,11.005608229059874,-4.55867190032194)"
        >
          <path
            d="M11.000341415405273,14.299999809265136L11.000341415405273,12.199999809265137L12.000341415405273,12.199999809265137L12.000341415405273,14.299999809265136L11.000341415405273,14.299999809265136Z"
            fill-rule="evenodd"
            fill="currentColor"
            fill-opacity="1"
          />
        </g>
        <g>
          <path
            d="M7.499999046325684,15.00000057220459L7.499999046325684,12.90000057220459L8.499999046325684,12.90000057220459L8.499999046325684,15.00000057220459L7.499999046325684,15.00000057220459Z"
            fill-rule="evenodd"
            fill="currentColor"
            fill-opacity="1"
          />
        </g>
      </g>
    </g>
  </svg>
</template>
